import { createFileRoute } from "@tanstack/react-router"
import { useQuery } from "convex/react"
import { api } from "../../convex/_generated/api"
import { AdminListPage, AdminRow } from "@/components/admin/admin-list-page"
import { AdminPersonLine } from "@/components/admin/admin-person-line"
import { StatusPill } from "@/components/status-pill"

function formatInr(paise: number) {
  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 0,
  }).format(paise / 100)
}

export const Route = createFileRoute("/admin/payments")({
  component: AdminPaymentsPage,
})

function AdminPaymentsPage() {
  const payments = useQuery(api.admin.listPayments)

  return (
    <AdminListPage
      title="Payments"
      description="Razorpay checkout history across the platform."
      data={payments}
      emptyCopy="No payments yet."
      renderRow={(payment) => (
        <AdminRow
          key={payment._id}
          title={
            payment.kind === "seeker_annual"
              ? "Seeker annual"
              : payment.kind === "employer_job_feature"
                ? "Featured job"
                : "Hackathon publish"
          }
          badges={
            <StatusPill domain="payment" status={payment.status} as="badge" />
          }
          meta={
            <span className="inline-flex flex-wrap items-center gap-x-1.5">
              <AdminPersonLine
                name={payment.profileName}
                email={payment.profileEmail}
                linkedinUrl={payment.profileLinkedinUrl}
              />
              <span aria-hidden>·</span>
              <span>{formatInr(payment.amountInPaise)}</span>
            </span>
          }
        >
          <p className="mt-1 text-xs text-[color:var(--wf-mute)]">
            Order {payment.razorpayOrderId}
          </p>
        </AdminRow>
      )}
    />
  )
}
